import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import formGroup1Global from './formGroupStep1Global/formGroup1Global';
import formGroup1IngestGlobal from './formGroupStep2Ingest/formGroup1IngestGlobal';
import formGroup2IngestServers from './formGroupStep2Ingest/formGroup2IngestServers';
import formGroup1Cameras from './formGroupStep3Cameras/formGroup1Cameras';
import formGroup2VideoOutputs from './formGroupStep3Cameras/formGroup2VideoOutputs';
import formGroup1MapConfiguration from './formGroupStep4CamerasPresentation/formGroup1MapConfiguration';
import formGroup1Status from './formGroupStep5Status/formGroup1Status';
import CamerasConfiguration from './formGroupStep4CamerasPresentation/formGroup11MapConfigurationFields';
import MapPreview from './formGroupStep4CamerasPresentation/formGroup12MapPreview';
import formGroup3VideoCodec from './formGroupStep2Ingest/formGroup3VideoCodec';

export default {
  title: 'Steps Live setup',
  attributeName: 'steps',
  validationUrl:'live',
  steps:[
    { id:1,
      name:"Global Live setup",
      attributeName:'globalLive',
      formConfig: [
        formGroup1Global,
      ],
    },
    { id:2,
      name:"Ingest setup",
      attributeName:'ingestLive',
      formConfig:[
        formGroup3VideoCodec,
        formGroup2IngestServers,
        formGroup1IngestGlobal,
      ]
    },
    { id:3,
      name:"Outputs configuration",
      attributeName:'camerasManagement',
      formConfig:[
        formGroup1Cameras,
        formGroup2VideoOutputs
      ]
    },
    { id:4,
      name:"Cameras presentation",
      attributeName:'camerasPresentation',
      formConfig:[
        formGroup1MapConfiguration,
        MapPreview,
        CamerasConfiguration,
        
      ]
    },
  ]
};
